import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';

import SentryIntegration from "@/common/sentry-integration";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

SentryIntegration.bind(Vue);

import "../css/app";
